import { render, staticRenderFns } from "./PlacementBookingTableForm.vue?vue&type=template&id=658cc9f4"
import script from "./PlacementBookingTableForm.vue?vue&type=script&lang=js"
export * from "./PlacementBookingTableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports